// extracted by mini-css-extract-plugin
export default {"cls1":"Lightbox-Image-module--cls1--fVE4m","cls2":"Lightbox-Image-module--cls2--P7z9u Lightbox-Image-module--cls1--fVE4m"};